/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Confirm_DeleteInputs */

const en_settings_apikeys_confirm_delete = /** @type {(inputs: Settings_Apikeys_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const zh_settings_apikeys_confirm_delete = /** @type {(inputs: Settings_Apikeys_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Settings_Apikeys_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_confirm_delete = /** @type {((inputs?: Settings_Apikeys_Confirm_DeleteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Confirm_DeleteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_confirm_delete(inputs)
	return zh_settings_apikeys_confirm_delete(inputs)
});
export { settings_apikeys_confirm_delete as "settings.apikeys.confirm_delete" }